/* tslint:disable */
/* eslint-disable */
/**
 * Chad API
 * API for Chad language learning application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Serializer for checking an exercise answer.
 * @export
 * @interface CheckAnswerRequestRequest
 */
export interface CheckAnswerRequestRequest {
    /**
     * Exercise ID
     * @type {number}
     * @memberof CheckAnswerRequestRequest
     */
    'exercise_id': number;
    /**
     * User\'s answer to the exercise
     * @type {string}
     * @memberof CheckAnswerRequestRequest
     */
    'user_answer': string;
}
/**
 * Serializer for answer check response.
 * @export
 * @interface CheckAnswerResponse
 */
export interface CheckAnswerResponse {
    /**
     * Whether the answer is correct
     * @type {boolean}
     * @memberof CheckAnswerResponse
     */
    'is_correct': boolean;
    /**
     * The correct answer
     * @type {string}
     * @memberof CheckAnswerResponse
     */
    'correct_answer': string;
    /**
     * Optional explanation of the answer
     * @type {string}
     * @memberof CheckAnswerResponse
     */
    'explanation': string;
    /**
     * The answer provided by the user
     * @type {string}
     * @memberof CheckAnswerResponse
     */
    'user_answer': string;
}
/**
 * Serializer for conversation detail.
 * @export
 * @interface ConversationDetail
 */
export interface ConversationDetail {
    /**
     * 
     * @type {number}
     * @memberof ConversationDetail
     */
    'conversation_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ConversationDetail
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationDetail
     */
    'conversation_language_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationDetail
     */
    'conversation_language_iso'?: string;
    /**
     * 
     * @type {ProficiencyLevelBc9Enum}
     * @memberof ConversationDetail
     */
    'proficiency_level'?: ProficiencyLevelBc9Enum;
    /**
     * 
     * @type {string}
     * @memberof ConversationDetail
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationDetail
     */
    'last_message_timestamp'?: string;
}


/**
 * Serializer for listing conversations.
 * @export
 * @interface ConversationList
 */
export interface ConversationList {
    /**
     * 
     * @type {number}
     * @memberof ConversationList
     */
    'conversation_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ConversationList
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationList
     */
    'conversation_language_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationList
     */
    'conversation_language_iso'?: string;
    /**
     * 
     * @type {ProficiencyLevelBc9Enum}
     * @memberof ConversationList
     */
    'proficiency_level'?: ProficiencyLevelBc9Enum;
    /**
     * 
     * @type {string}
     * @memberof ConversationList
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationList
     */
    'last_message_timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationList
     */
    'message_count'?: string;
}


/**
 * Serializer for conversation request payload.
 * @export
 * @interface ConversationRequestRequest
 */
export interface ConversationRequestRequest {
    /**
     * List of recent messages in the conversation
     * @type {Array<MessageInputRequest>}
     * @memberof ConversationRequestRequest
     */
    'message_list': Array<MessageInputRequest>;
    /**
     * ISO 639 language code (e.g., \'en-US\', \'es-ES\', \'de-DE\')
     * @type {string}
     * @memberof ConversationRequestRequest
     */
    'conversation_language'?: string | null;
}
/**
 * Serializer for AI response to a message.
 * @export
 * @interface ConversationResponse
 */
export interface ConversationResponse {
    /**
     * Generated message ID
     * @type {string}
     * @memberof ConversationResponse
     */
    'message_id': string;
    /**
     * Always \'assistant\'
     * @type {string}
     * @memberof ConversationResponse
     */
    'role': string;
    /**
     * AI assistant\'s response
     * @type {string}
     * @memberof ConversationResponse
     */
    'content': string;
    /**
     * Response timestamp
     * @type {string}
     * @memberof ConversationResponse
     */
    'dateTime': string;
    /**
     * Conversation ID
     * @type {number}
     * @memberof ConversationResponse
     */
    'conversation_id': number;
}
/**
 * Serializer for creating a new conversation.
 * @export
 * @interface CreateConversationRequest
 */
export interface CreateConversationRequest {
    /**
     * Title for the conversation
     * @type {string}
     * @memberof CreateConversationRequest
     */
    'title'?: string;
    /**
     * ISO 639 language code (e.g., \'en-US\', \'es-ES\', \'de-DE\')
     * @type {string}
     * @memberof CreateConversationRequest
     */
    'conversation_language': string;
    /**
     * CEFR proficiency level  * `A1` - A1 * `A2` - A2 * `B1` - B1 * `B2` - B2 * `C1` - C1 * `C2` - C2
     * @type {ProficiencyLevel201Enum}
     * @memberof CreateConversationRequest
     */
    'proficiency_level'?: ProficiencyLevel201Enum;
}


/**
 * Serializer for requesting an exercise.
 * @export
 * @interface ExerciseRequestRequest
 */
export interface ExerciseRequestRequest {
    /**
     * 
     * @type {ProficiencyLevel201Enum}
     * @memberof ExerciseRequestRequest
     */
    'proficiency_level'?: ProficiencyLevel201Enum | null;
    /**
     * ISO 639 language code (e.g., \'en-US\', \'es-ES\', \'de-DE\')
     * @type {string}
     * @memberof ExerciseRequestRequest
     */
    'language': string;
    /**
     * Grammar topic ID (optional - will select random if not provided)
     * @type {number}
     * @memberof ExerciseRequestRequest
     */
    'grammar_topic_id'?: number | null;
}


/**
 * Serializer for exercise response.
 * @export
 * @interface ExerciseResponse
 */
export interface ExerciseResponse {
    /**
     * 
     * @type {number}
     * @memberof ExerciseResponse
     */
    'exercise_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ExerciseResponse
     */
    'grammar_topic_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ExerciseResponse
     */
    'grammar_topic_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExerciseResponse
     */
    'proficiency_level'?: string;
    /**
     * The exercise question. Use _ for blanks (e.g., \'Anoche _ pegué en la rodilla\')
     * @type {string}
     * @memberof ExerciseResponse
     */
    'question': string;
    /**
     * The correct answer (will be normalized for comparison)
     * @type {string}
     * @memberof ExerciseResponse
     */
    'answer': string;
    /**
     * Optional explanation of the correct answer
     * @type {string}
     * @memberof ExerciseResponse
     */
    'explanation'?: string;
    /**
     * Optional list of multiple choice options (e.g., [\'me\', \'mi\', \'yo\'])
     * @type {any}
     * @memberof ExerciseResponse
     */
    'options'?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ExerciseResponse
     */
    'is_multiple_choice'?: string;
}
/**
 * Serializer for GrammarTopic model.
 * @export
 * @interface GrammarTopic
 */
export interface GrammarTopic {
    /**
     * 
     * @type {number}
     * @memberof GrammarTopic
     */
    'grammar_topic_id'?: number;
    /**
     * Name of the grammar topic (e.g., \'Present Perfect\', \'Pretérito Indefinido\')
     * @type {string}
     * @memberof GrammarTopic
     */
    'name': string;
    /**
     * Optional description of the grammar topic
     * @type {string}
     * @memberof GrammarTopic
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GrammarTopic
     */
    'language_iso'?: string;
    /**
     * 
     * @type {string}
     * @memberof GrammarTopic
     */
    'language_name'?: string;
    /**
     * CEFR proficiency level for this topic  * `A1` - Beginner (A1) * `A2` - Elementary (A2) * `B1` - Intermediate (B1) * `B2` - Upper Intermediate (B2) * `C1` - Advanced (C1) * `C2` - Proficient (C2)
     * @type {ProficiencyLevelBc9Enum}
     * @memberof GrammarTopic
     */
    'proficiency_level': ProficiencyLevelBc9Enum;
    /**
     * 
     * @type {string}
     * @memberof GrammarTopic
     */
    'exercise_count'?: string;
    /**
     * 
     * @type {string}
     * @memberof GrammarTopic
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GrammarTopic
     */
    'updated_at'?: string;
}


/**
 * 
 * @export
 * @interface Language
 */
export interface Language {
    /**
     * 
     * @type {string}
     * @memberof Language
     */
    'iso639_tag': string;
    /**
     * 
     * @type {string}
     * @memberof Language
     */
    'name': string;
}
/**
 * Serializer for last messages response.
 * @export
 * @interface LastMessagesResponse
 */
export interface LastMessagesResponse {
    /**
     * List of recent messages
     * @type {Array<MessageOutput>}
     * @memberof LastMessagesResponse
     */
    'serialized_messages': Array<MessageOutput>;
    /**
     * ID of the latest conversation
     * @type {number}
     * @memberof LastMessagesResponse
     */
    'latest_conversation_id': number;
    /**
     * Language ISO code of the conversation
     * @type {string}
     * @memberof LastMessagesResponse
     */
    'latest_conversation_language': string;
}
/**
 * Serializer for incoming message in message_list.
 * @export
 * @interface MessageInputRequest
 */
export interface MessageInputRequest {
    /**
     * 
     * @type {string}
     * @memberof MessageInputRequest
     */
    'message_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof MessageInputRequest
     */
    'role': string;
    /**
     * 
     * @type {string}
     * @memberof MessageInputRequest
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof MessageInputRequest
     */
    'dateTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof MessageInputRequest
     */
    'conversation_id'?: number;
}
/**
 * Serializer for a single message in responses.
 * @export
 * @interface MessageOutput
 */
export interface MessageOutput {
    /**
     * 
     * @type {string}
     * @memberof MessageOutput
     */
    'message_id': string;
    /**
     * 
     * @type {string}
     * @memberof MessageOutput
     */
    'role': string;
    /**
     * 
     * @type {string}
     * @memberof MessageOutput
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof MessageOutput
     */
    'dateTime': string;
    /**
     * 
     * @type {number}
     * @memberof MessageOutput
     */
    'conversation_id': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const NullEnum = {
} as const;

export type NullEnum = typeof NullEnum[keyof typeof NullEnum];


/**
 * 
 * @export
 * @interface PatchedUserMarkedWordRequest
 */
export interface PatchedUserMarkedWordRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedUserMarkedWordRequest
     */
    'word_base_form'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedUserMarkedWordRequest
     */
    'word_translation'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedUserMarkedWordRequest
     */
    'grammar'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedUserMarkedWordRequest
     */
    'example_sentence'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedUserMarkedWordRequest
     */
    'example_sentence_translation'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedUserMarkedWordRequest
     */
    'word_original_language'?: string;
    /**
     * Score from 1 (just learned) to 100 (well mastered)
     * @type {number}
     * @memberof PatchedUserMarkedWordRequest
     */
    'score'?: number;
}
/**
 * * `A1` - A1 * `A2` - A2 * `B1` - B1 * `B2` - B2 * `C1` - C1 * `C2` - C2
 * @export
 * @enum {string}
 */

export const ProficiencyLevel201Enum = {
    A1: 'A1',
    A2: 'A2',
    B1: 'B1',
    B2: 'B2',
    C1: 'C1',
    C2: 'C2'
} as const;

export type ProficiencyLevel201Enum = typeof ProficiencyLevel201Enum[keyof typeof ProficiencyLevel201Enum];


/**
 * * `A1` - Beginner (A1) * `A2` - Elementary (A2) * `B1` - Intermediate (B1) * `B2` - Upper Intermediate (B2) * `C1` - Advanced (C1) * `C2` - Proficient (C2)
 * @export
 * @enum {string}
 */

export const ProficiencyLevelBc9Enum = {
    A1: 'A1',
    A2: 'A2',
    B1: 'B1',
    B2: 'B2',
    C1: 'C1',
    C2: 'C2'
} as const;

export type ProficiencyLevelBc9Enum = typeof ProficiencyLevelBc9Enum[keyof typeof ProficiencyLevelBc9Enum];


/**
 * 
 * @export
 * @interface TokenObtainPair
 */
export interface TokenObtainPair {
    /**
     * 
     * @type {string}
     * @memberof TokenObtainPair
     */
    'access'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenObtainPair
     */
    'refresh'?: string;
}
/**
 * 
 * @export
 * @interface TokenObtainPairRequest
 */
export interface TokenObtainPairRequest {
    /**
     * 
     * @type {string}
     * @memberof TokenObtainPairRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof TokenObtainPairRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface TokenRefresh
 */
export interface TokenRefresh {
    /**
     * 
     * @type {string}
     * @memberof TokenRefresh
     */
    'access'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenRefresh
     */
    'refresh': string;
}
/**
 * 
 * @export
 * @interface TokenRefreshRequest
 */
export interface TokenRefreshRequest {
    /**
     * 
     * @type {string}
     * @memberof TokenRefreshRequest
     */
    'refresh': string;
}
/**
 * 
 * @export
 * @interface TokenUsage
 */
export interface TokenUsage {
    /**
     * 
     * @type {number}
     * @memberof TokenUsage
     */
    'total_chat_tokens': number;
    /**
     * 
     * @type {number}
     * @memberof TokenUsage
     */
    'total_wordexplorer_tokens': number;
    /**
     * 
     * @type {number}
     * @memberof TokenUsage
     */
    'tts_characters_used': number;
}
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'native_language': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'preferred_explanation_language': string;
}
/**
 * 
 * @export
 * @interface UserCreateRequest
 */
export interface UserCreateRequest {
    /**
     * User\'s email address
     * @type {string}
     * @memberof UserCreateRequest
     */
    'email': string;
    /**
     * User\'s password
     * @type {string}
     * @memberof UserCreateRequest
     */
    'password': string;
    /**
     * User\'s first name
     * @type {string}
     * @memberof UserCreateRequest
     */
    'first_name': string;
    /**
     * ISO 639 code for native language
     * @type {string}
     * @memberof UserCreateRequest
     */
    'native_language_iso639': string;
    /**
     * ISO 639 code for target language
     * @type {string}
     * @memberof UserCreateRequest
     */
    'target_language_iso639': string;
    /**
     * ISO 639 code for preferred explanation language
     * @type {string}
     * @memberof UserCreateRequest
     */
    'preferred_explanation_language_iso639': string;
}
/**
 * 
 * @export
 * @interface UserCreateResponse
 */
export interface UserCreateResponse {
    /**
     * JWT refresh token
     * @type {string}
     * @memberof UserCreateResponse
     */
    'refresh': string;
    /**
     * JWT access token
     * @type {string}
     * @memberof UserCreateResponse
     */
    'access': string;
    /**
     * Created user information
     * @type {User}
     * @memberof UserCreateResponse
     */
    'user': User;
}
/**
 * Serializer for user exercise attempts.
 * @export
 * @interface UserExerciseAttempt
 */
export interface UserExerciseAttempt {
    /**
     * 
     * @type {number}
     * @memberof UserExerciseAttempt
     */
    'attempt_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserExerciseAttempt
     */
    'exercise_question'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserExerciseAttempt
     */
    'grammar_topic_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserExerciseAttempt
     */
    'user_answer': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserExerciseAttempt
     */
    'is_correct': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserExerciseAttempt
     */
    'attempted_at'?: string;
}
/**
 * 
 * @export
 * @interface UserMarkedWord
 */
export interface UserMarkedWord {
    /**
     * 
     * @type {number}
     * @memberof UserMarkedWord
     */
    'user_marked_word_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserMarkedWord
     */
    'word_base_form': string;
    /**
     * 
     * @type {string}
     * @memberof UserMarkedWord
     */
    'word_translation': string;
    /**
     * 
     * @type {string}
     * @memberof UserMarkedWord
     */
    'grammar': string;
    /**
     * 
     * @type {string}
     * @memberof UserMarkedWord
     */
    'example_sentence': string;
    /**
     * 
     * @type {string}
     * @memberof UserMarkedWord
     */
    'example_sentence_translation': string;
    /**
     * 
     * @type {string}
     * @memberof UserMarkedWord
     */
    'word_original_language'?: string;
    /**
     * Score from 1 (just learned) to 100 (well mastered)
     * @type {number}
     * @memberof UserMarkedWord
     */
    'score'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserMarkedWord
     */
    'created_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserMarkedWord
     */
    'updated_at'?: string | null;
}
/**
 * 
 * @export
 * @interface UserMarkedWordRequest
 */
export interface UserMarkedWordRequest {
    /**
     * 
     * @type {string}
     * @memberof UserMarkedWordRequest
     */
    'word_base_form': string;
    /**
     * 
     * @type {string}
     * @memberof UserMarkedWordRequest
     */
    'word_translation': string;
    /**
     * 
     * @type {string}
     * @memberof UserMarkedWordRequest
     */
    'grammar': string;
    /**
     * 
     * @type {string}
     * @memberof UserMarkedWordRequest
     */
    'example_sentence': string;
    /**
     * 
     * @type {string}
     * @memberof UserMarkedWordRequest
     */
    'example_sentence_translation': string;
    /**
     * 
     * @type {string}
     * @memberof UserMarkedWordRequest
     */
    'word_original_language'?: string;
    /**
     * Score from 1 (just learned) to 100 (well mastered)
     * @type {number}
     * @memberof UserMarkedWordRequest
     */
    'score'?: number;
}
/**
 * 
 * @export
 * @interface UserOptionsResponse
 */
export interface UserOptionsResponse {
    /**
     * User\'s native language ISO code
     * @type {string}
     * @memberof UserOptionsResponse
     */
    'user_native_language': string;
    /**
     * User\'s email
     * @type {string}
     * @memberof UserOptionsResponse
     */
    'user_email': string;
    /**
     * User\'s first name
     * @type {string}
     * @memberof UserOptionsResponse
     */
    'user_first_name': string;
}
/**
 * 
 * @export
 * @interface UserProfileResponse
 */
export interface UserProfileResponse {
    /**
     * User\'s email
     * @type {string}
     * @memberof UserProfileResponse
     */
    'email': string;
    /**
     * User\'s first name
     * @type {string}
     * @memberof UserProfileResponse
     */
    'first_name': string;
    /**
     * User\'s native language details
     * @type {Language}
     * @memberof UserProfileResponse
     */
    'native_language': Language;
    /**
     * User\'s preferred explanation language details
     * @type {Language}
     * @memberof UserProfileResponse
     */
    'preferred_explanation_language': Language;
    /**
     * User registration date
     * @type {string}
     * @memberof UserProfileResponse
     */
    'date_joined': string;
    /**
     * User\'s token usage statistics
     * @type {TokenUsage}
     * @memberof UserProfileResponse
     */
    'token_usage': TokenUsage | null;
}
/**
 * 
 * @export
 * @interface UsersAvailableLanguagesRetrieve200ResponseInner
 */
export interface UsersAvailableLanguagesRetrieve200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof UsersAvailableLanguagesRetrieve200ResponseInner
     */
    'language_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UsersAvailableLanguagesRetrieve200ResponseInner
     */
    'language_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UsersAvailableLanguagesRetrieve200ResponseInner
     */
    'iso639_tag'?: string;
}
/**
 * 
 * @export
 * @interface UsersIndexRetrieve200Response
 */
export interface UsersIndexRetrieve200Response {
    /**
     * 
     * @type {string}
     * @memberof UsersIndexRetrieve200Response
     */
    'message'?: string;
}

/**
 * ChatApi - axios parameter creator
 * @export
 */
export const ChatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Send a message and get AI tutor response
         * @param {ConversationRequestRequest} conversationRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatConversationCreate: async (conversationRequestRequest: ConversationRequestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationRequestRequest' is not null or undefined
            assertParamExists('chatConversationCreate', 'conversationRequestRequest', conversationRequestRequest)
            const localVarPath = `/chat/conversation/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conversationRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new conversation with specified language and proficiency level
         * @param {CreateConversationRequest} createConversationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatCreateConversationCreate: async (createConversationRequest: CreateConversationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createConversationRequest' is not null or undefined
            assertParamExists('chatCreateConversationCreate', 'createConversationRequest', createConversationRequest)
            const localVarPath = `/chat/create_conversation/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createConversationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the last 5 messages from your most recent conversation or a specific conversation
         * @param {number | null} [conversationId] Optional conversation ID to get messages from a specific conversation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatLastMessagesRetrieve: async (conversationId?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/chat/last_messages/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (conversationId !== undefined) {
                localVarQueryParameter['conversation_id'] = conversationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of all user\'s conversations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatListConversationsList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/chat/list_conversations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatApi - functional programming interface
 * @export
 */
export const ChatApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatApiAxiosParamCreator(configuration)
    return {
        /**
         * Send a message and get AI tutor response
         * @param {ConversationRequestRequest} conversationRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatConversationCreate(conversationRequestRequest: ConversationRequestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatConversationCreate(conversationRequestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.chatConversationCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new conversation with specified language and proficiency level
         * @param {CreateConversationRequest} createConversationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatCreateConversationCreate(createConversationRequest: CreateConversationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatCreateConversationCreate(createConversationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.chatCreateConversationCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the last 5 messages from your most recent conversation or a specific conversation
         * @param {number | null} [conversationId] Optional conversation ID to get messages from a specific conversation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatLastMessagesRetrieve(conversationId?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LastMessagesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatLastMessagesRetrieve(conversationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.chatLastMessagesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get list of all user\'s conversations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatListConversationsList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConversationList>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatListConversationsList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.chatListConversationsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatApi - factory interface
 * @export
 */
export const ChatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatApiFp(configuration)
    return {
        /**
         * Send a message and get AI tutor response
         * @param {ConversationRequestRequest} conversationRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatConversationCreate(conversationRequestRequest: ConversationRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConversationResponse> {
            return localVarFp.chatConversationCreate(conversationRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new conversation with specified language and proficiency level
         * @param {CreateConversationRequest} createConversationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatCreateConversationCreate(createConversationRequest: CreateConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConversationDetail> {
            return localVarFp.chatCreateConversationCreate(createConversationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the last 5 messages from your most recent conversation or a specific conversation
         * @param {number | null} [conversationId] Optional conversation ID to get messages from a specific conversation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatLastMessagesRetrieve(conversationId?: number | null, options?: RawAxiosRequestConfig): AxiosPromise<LastMessagesResponse> {
            return localVarFp.chatLastMessagesRetrieve(conversationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of all user\'s conversations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatListConversationsList(options?: RawAxiosRequestConfig): AxiosPromise<Array<ConversationList>> {
            return localVarFp.chatListConversationsList(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChatApi - object-oriented interface
 * @export
 * @class ChatApi
 * @extends {BaseAPI}
 */
export class ChatApi extends BaseAPI {
    /**
     * Send a message and get AI tutor response
     * @param {ConversationRequestRequest} conversationRequestRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public chatConversationCreate(conversationRequestRequest: ConversationRequestRequest, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).chatConversationCreate(conversationRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new conversation with specified language and proficiency level
     * @param {CreateConversationRequest} createConversationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public chatCreateConversationCreate(createConversationRequest: CreateConversationRequest, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).chatCreateConversationCreate(createConversationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the last 5 messages from your most recent conversation or a specific conversation
     * @param {number | null} [conversationId] Optional conversation ID to get messages from a specific conversation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public chatLastMessagesRetrieve(conversationId?: number | null, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).chatLastMessagesRetrieve(conversationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of all user\'s conversations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public chatListConversationsList(options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).chatListConversationsList(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DictionaryApi - axios parameter creator
 * @export
 */
export const DictionaryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * A viewset for CRUD operations on UserMarkedWord (user\'s personal dictionary).  List endpoint supports filtering by language with query param ?language=en-US
         * @param {UserMarkedWordRequest} userMarkedWordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryCreate: async (userMarkedWordRequest: UserMarkedWordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userMarkedWordRequest' is not null or undefined
            assertParamExists('dictionaryCreate', 'userMarkedWordRequest', userMarkedWordRequest)
            const localVarPath = `/dictionary/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userMarkedWordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A viewset for CRUD operations on UserMarkedWord (user\'s personal dictionary).  List endpoint supports filtering by language with query param ?language=en-US
         * @param {number} userMarkedWordId A unique integer value identifying this User Marked Word.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryDestroy: async (userMarkedWordId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userMarkedWordId' is not null or undefined
            assertParamExists('dictionaryDestroy', 'userMarkedWordId', userMarkedWordId)
            const localVarPath = `/dictionary/{user_marked_word_id}/`
                .replace(`{${"user_marked_word_id"}}`, encodeURIComponent(String(userMarkedWordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of languages that have words in the user\'s dictionary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryLanguagesRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/dictionary/languages/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A viewset for CRUD operations on UserMarkedWord (user\'s personal dictionary).  List endpoint supports filtering by language with query param ?language=en-US
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/dictionary/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A viewset for CRUD operations on UserMarkedWord (user\'s personal dictionary).  List endpoint supports filtering by language with query param ?language=en-US
         * @param {number} userMarkedWordId A unique integer value identifying this User Marked Word.
         * @param {PatchedUserMarkedWordRequest} [patchedUserMarkedWordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryPartialUpdate: async (userMarkedWordId: number, patchedUserMarkedWordRequest?: PatchedUserMarkedWordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userMarkedWordId' is not null or undefined
            assertParamExists('dictionaryPartialUpdate', 'userMarkedWordId', userMarkedWordId)
            const localVarPath = `/dictionary/{user_marked_word_id}/`
                .replace(`{${"user_marked_word_id"}}`, encodeURIComponent(String(userMarkedWordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedUserMarkedWordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A viewset for CRUD operations on UserMarkedWord (user\'s personal dictionary).  List endpoint supports filtering by language with query param ?language=en-US
         * @param {number} userMarkedWordId A unique integer value identifying this User Marked Word.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryRetrieve: async (userMarkedWordId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userMarkedWordId' is not null or undefined
            assertParamExists('dictionaryRetrieve', 'userMarkedWordId', userMarkedWordId)
            const localVarPath = `/dictionary/{user_marked_word_id}/`
                .replace(`{${"user_marked_word_id"}}`, encodeURIComponent(String(userMarkedWordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A viewset for CRUD operations on UserMarkedWord (user\'s personal dictionary).  List endpoint supports filtering by language with query param ?language=en-US
         * @param {number} userMarkedWordId A unique integer value identifying this User Marked Word.
         * @param {UserMarkedWordRequest} userMarkedWordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryUpdate: async (userMarkedWordId: number, userMarkedWordRequest: UserMarkedWordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userMarkedWordId' is not null or undefined
            assertParamExists('dictionaryUpdate', 'userMarkedWordId', userMarkedWordId)
            // verify required parameter 'userMarkedWordRequest' is not null or undefined
            assertParamExists('dictionaryUpdate', 'userMarkedWordRequest', userMarkedWordRequest)
            const localVarPath = `/dictionary/{user_marked_word_id}/`
                .replace(`{${"user_marked_word_id"}}`, encodeURIComponent(String(userMarkedWordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userMarkedWordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DictionaryApi - functional programming interface
 * @export
 */
export const DictionaryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DictionaryApiAxiosParamCreator(configuration)
    return {
        /**
         * A viewset for CRUD operations on UserMarkedWord (user\'s personal dictionary).  List endpoint supports filtering by language with query param ?language=en-US
         * @param {UserMarkedWordRequest} userMarkedWordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dictionaryCreate(userMarkedWordRequest: UserMarkedWordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserMarkedWord>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dictionaryCreate(userMarkedWordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionaryApi.dictionaryCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * A viewset for CRUD operations on UserMarkedWord (user\'s personal dictionary).  List endpoint supports filtering by language with query param ?language=en-US
         * @param {number} userMarkedWordId A unique integer value identifying this User Marked Word.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dictionaryDestroy(userMarkedWordId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dictionaryDestroy(userMarkedWordId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionaryApi.dictionaryDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get list of languages that have words in the user\'s dictionary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dictionaryLanguagesRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserMarkedWord>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dictionaryLanguagesRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionaryApi.dictionaryLanguagesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * A viewset for CRUD operations on UserMarkedWord (user\'s personal dictionary).  List endpoint supports filtering by language with query param ?language=en-US
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dictionaryList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserMarkedWord>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dictionaryList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionaryApi.dictionaryList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * A viewset for CRUD operations on UserMarkedWord (user\'s personal dictionary).  List endpoint supports filtering by language with query param ?language=en-US
         * @param {number} userMarkedWordId A unique integer value identifying this User Marked Word.
         * @param {PatchedUserMarkedWordRequest} [patchedUserMarkedWordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dictionaryPartialUpdate(userMarkedWordId: number, patchedUserMarkedWordRequest?: PatchedUserMarkedWordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserMarkedWord>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dictionaryPartialUpdate(userMarkedWordId, patchedUserMarkedWordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionaryApi.dictionaryPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * A viewset for CRUD operations on UserMarkedWord (user\'s personal dictionary).  List endpoint supports filtering by language with query param ?language=en-US
         * @param {number} userMarkedWordId A unique integer value identifying this User Marked Word.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dictionaryRetrieve(userMarkedWordId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserMarkedWord>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dictionaryRetrieve(userMarkedWordId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionaryApi.dictionaryRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * A viewset for CRUD operations on UserMarkedWord (user\'s personal dictionary).  List endpoint supports filtering by language with query param ?language=en-US
         * @param {number} userMarkedWordId A unique integer value identifying this User Marked Word.
         * @param {UserMarkedWordRequest} userMarkedWordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dictionaryUpdate(userMarkedWordId: number, userMarkedWordRequest: UserMarkedWordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserMarkedWord>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dictionaryUpdate(userMarkedWordId, userMarkedWordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionaryApi.dictionaryUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DictionaryApi - factory interface
 * @export
 */
export const DictionaryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DictionaryApiFp(configuration)
    return {
        /**
         * A viewset for CRUD operations on UserMarkedWord (user\'s personal dictionary).  List endpoint supports filtering by language with query param ?language=en-US
         * @param {UserMarkedWordRequest} userMarkedWordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryCreate(userMarkedWordRequest: UserMarkedWordRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserMarkedWord> {
            return localVarFp.dictionaryCreate(userMarkedWordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * A viewset for CRUD operations on UserMarkedWord (user\'s personal dictionary).  List endpoint supports filtering by language with query param ?language=en-US
         * @param {number} userMarkedWordId A unique integer value identifying this User Marked Word.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryDestroy(userMarkedWordId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.dictionaryDestroy(userMarkedWordId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of languages that have words in the user\'s dictionary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryLanguagesRetrieve(options?: RawAxiosRequestConfig): AxiosPromise<UserMarkedWord> {
            return localVarFp.dictionaryLanguagesRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * A viewset for CRUD operations on UserMarkedWord (user\'s personal dictionary).  List endpoint supports filtering by language with query param ?language=en-US
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryList(options?: RawAxiosRequestConfig): AxiosPromise<Array<UserMarkedWord>> {
            return localVarFp.dictionaryList(options).then((request) => request(axios, basePath));
        },
        /**
         * A viewset for CRUD operations on UserMarkedWord (user\'s personal dictionary).  List endpoint supports filtering by language with query param ?language=en-US
         * @param {number} userMarkedWordId A unique integer value identifying this User Marked Word.
         * @param {PatchedUserMarkedWordRequest} [patchedUserMarkedWordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryPartialUpdate(userMarkedWordId: number, patchedUserMarkedWordRequest?: PatchedUserMarkedWordRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserMarkedWord> {
            return localVarFp.dictionaryPartialUpdate(userMarkedWordId, patchedUserMarkedWordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * A viewset for CRUD operations on UserMarkedWord (user\'s personal dictionary).  List endpoint supports filtering by language with query param ?language=en-US
         * @param {number} userMarkedWordId A unique integer value identifying this User Marked Word.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryRetrieve(userMarkedWordId: number, options?: RawAxiosRequestConfig): AxiosPromise<UserMarkedWord> {
            return localVarFp.dictionaryRetrieve(userMarkedWordId, options).then((request) => request(axios, basePath));
        },
        /**
         * A viewset for CRUD operations on UserMarkedWord (user\'s personal dictionary).  List endpoint supports filtering by language with query param ?language=en-US
         * @param {number} userMarkedWordId A unique integer value identifying this User Marked Word.
         * @param {UserMarkedWordRequest} userMarkedWordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryUpdate(userMarkedWordId: number, userMarkedWordRequest: UserMarkedWordRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserMarkedWord> {
            return localVarFp.dictionaryUpdate(userMarkedWordId, userMarkedWordRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DictionaryApi - object-oriented interface
 * @export
 * @class DictionaryApi
 * @extends {BaseAPI}
 */
export class DictionaryApi extends BaseAPI {
    /**
     * A viewset for CRUD operations on UserMarkedWord (user\'s personal dictionary).  List endpoint supports filtering by language with query param ?language=en-US
     * @param {UserMarkedWordRequest} userMarkedWordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionaryApi
     */
    public dictionaryCreate(userMarkedWordRequest: UserMarkedWordRequest, options?: RawAxiosRequestConfig) {
        return DictionaryApiFp(this.configuration).dictionaryCreate(userMarkedWordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A viewset for CRUD operations on UserMarkedWord (user\'s personal dictionary).  List endpoint supports filtering by language with query param ?language=en-US
     * @param {number} userMarkedWordId A unique integer value identifying this User Marked Word.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionaryApi
     */
    public dictionaryDestroy(userMarkedWordId: number, options?: RawAxiosRequestConfig) {
        return DictionaryApiFp(this.configuration).dictionaryDestroy(userMarkedWordId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of languages that have words in the user\'s dictionary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionaryApi
     */
    public dictionaryLanguagesRetrieve(options?: RawAxiosRequestConfig) {
        return DictionaryApiFp(this.configuration).dictionaryLanguagesRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A viewset for CRUD operations on UserMarkedWord (user\'s personal dictionary).  List endpoint supports filtering by language with query param ?language=en-US
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionaryApi
     */
    public dictionaryList(options?: RawAxiosRequestConfig) {
        return DictionaryApiFp(this.configuration).dictionaryList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A viewset for CRUD operations on UserMarkedWord (user\'s personal dictionary).  List endpoint supports filtering by language with query param ?language=en-US
     * @param {number} userMarkedWordId A unique integer value identifying this User Marked Word.
     * @param {PatchedUserMarkedWordRequest} [patchedUserMarkedWordRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionaryApi
     */
    public dictionaryPartialUpdate(userMarkedWordId: number, patchedUserMarkedWordRequest?: PatchedUserMarkedWordRequest, options?: RawAxiosRequestConfig) {
        return DictionaryApiFp(this.configuration).dictionaryPartialUpdate(userMarkedWordId, patchedUserMarkedWordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A viewset for CRUD operations on UserMarkedWord (user\'s personal dictionary).  List endpoint supports filtering by language with query param ?language=en-US
     * @param {number} userMarkedWordId A unique integer value identifying this User Marked Word.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionaryApi
     */
    public dictionaryRetrieve(userMarkedWordId: number, options?: RawAxiosRequestConfig) {
        return DictionaryApiFp(this.configuration).dictionaryRetrieve(userMarkedWordId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A viewset for CRUD operations on UserMarkedWord (user\'s personal dictionary).  List endpoint supports filtering by language with query param ?language=en-US
     * @param {number} userMarkedWordId A unique integer value identifying this User Marked Word.
     * @param {UserMarkedWordRequest} userMarkedWordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionaryApi
     */
    public dictionaryUpdate(userMarkedWordId: number, userMarkedWordRequest: UserMarkedWordRequest, options?: RawAxiosRequestConfig) {
        return DictionaryApiFp(this.configuration).dictionaryUpdate(userMarkedWordId, userMarkedWordRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GrammarPracticeApi - axios parameter creator
 * @export
 */
export const GrammarPracticeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Check if the user\'s answer to an exercise is correct
         * @param {CheckAnswerRequestRequest} checkAnswerRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grammarPracticeCheckAnswerCreate: async (checkAnswerRequestRequest: CheckAnswerRequestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkAnswerRequestRequest' is not null or undefined
            assertParamExists('grammarPracticeCheckAnswerCreate', 'checkAnswerRequestRequest', checkAnswerRequestRequest)
            const localVarPath = `/grammar_practice/check_answer/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkAnswerRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a random exercise based on filters (language, proficiency level, grammar topic)
         * @param {ExerciseRequestRequest} exerciseRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grammarPracticeGetExerciseCreate: async (exerciseRequestRequest: ExerciseRequestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exerciseRequestRequest' is not null or undefined
            assertParamExists('grammarPracticeGetExerciseCreate', 'exerciseRequestRequest', exerciseRequestRequest)
            const localVarPath = `/grammar_practice/get_exercise/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exerciseRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List available grammar topics for a language with optional proficiency level filter
         * @param {string} language ISO 639 language code (required)
         * @param {GrammarPracticeListTopicsListProficiencyLevelEnum} [proficiencyLevel] CEFR proficiency level (optional - will list all levels if not provided)  * &#x60;A1&#x60; - A1 * &#x60;A2&#x60; - A2 * &#x60;B1&#x60; - B1 * &#x60;B2&#x60; - B2 * &#x60;C1&#x60; - C1 * &#x60;C2&#x60; - C2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grammarPracticeListTopicsList: async (language: string, proficiencyLevel?: GrammarPracticeListTopicsListProficiencyLevelEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('grammarPracticeListTopicsList', 'language', language)
            const localVarPath = `/grammar_practice/list_topics/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (proficiencyLevel !== undefined) {
                localVarQueryParameter['proficiency_level'] = proficiencyLevel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get user\'s exercise attempt history
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grammarPracticeMyAttemptsList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/grammar_practice/my_attempts/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GrammarPracticeApi - functional programming interface
 * @export
 */
export const GrammarPracticeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GrammarPracticeApiAxiosParamCreator(configuration)
    return {
        /**
         * Check if the user\'s answer to an exercise is correct
         * @param {CheckAnswerRequestRequest} checkAnswerRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grammarPracticeCheckAnswerCreate(checkAnswerRequestRequest: CheckAnswerRequestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckAnswerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grammarPracticeCheckAnswerCreate(checkAnswerRequestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GrammarPracticeApi.grammarPracticeCheckAnswerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a random exercise based on filters (language, proficiency level, grammar topic)
         * @param {ExerciseRequestRequest} exerciseRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grammarPracticeGetExerciseCreate(exerciseRequestRequest: ExerciseRequestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExerciseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grammarPracticeGetExerciseCreate(exerciseRequestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GrammarPracticeApi.grammarPracticeGetExerciseCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List available grammar topics for a language with optional proficiency level filter
         * @param {string} language ISO 639 language code (required)
         * @param {GrammarPracticeListTopicsListProficiencyLevelEnum} [proficiencyLevel] CEFR proficiency level (optional - will list all levels if not provided)  * &#x60;A1&#x60; - A1 * &#x60;A2&#x60; - A2 * &#x60;B1&#x60; - B1 * &#x60;B2&#x60; - B2 * &#x60;C1&#x60; - C1 * &#x60;C2&#x60; - C2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grammarPracticeListTopicsList(language: string, proficiencyLevel?: GrammarPracticeListTopicsListProficiencyLevelEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GrammarTopic>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grammarPracticeListTopicsList(language, proficiencyLevel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GrammarPracticeApi.grammarPracticeListTopicsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get user\'s exercise attempt history
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grammarPracticeMyAttemptsList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserExerciseAttempt>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grammarPracticeMyAttemptsList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GrammarPracticeApi.grammarPracticeMyAttemptsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GrammarPracticeApi - factory interface
 * @export
 */
export const GrammarPracticeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GrammarPracticeApiFp(configuration)
    return {
        /**
         * Check if the user\'s answer to an exercise is correct
         * @param {CheckAnswerRequestRequest} checkAnswerRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grammarPracticeCheckAnswerCreate(checkAnswerRequestRequest: CheckAnswerRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<CheckAnswerResponse> {
            return localVarFp.grammarPracticeCheckAnswerCreate(checkAnswerRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a random exercise based on filters (language, proficiency level, grammar topic)
         * @param {ExerciseRequestRequest} exerciseRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grammarPracticeGetExerciseCreate(exerciseRequestRequest: ExerciseRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExerciseResponse> {
            return localVarFp.grammarPracticeGetExerciseCreate(exerciseRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * List available grammar topics for a language with optional proficiency level filter
         * @param {string} language ISO 639 language code (required)
         * @param {GrammarPracticeListTopicsListProficiencyLevelEnum} [proficiencyLevel] CEFR proficiency level (optional - will list all levels if not provided)  * &#x60;A1&#x60; - A1 * &#x60;A2&#x60; - A2 * &#x60;B1&#x60; - B1 * &#x60;B2&#x60; - B2 * &#x60;C1&#x60; - C1 * &#x60;C2&#x60; - C2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grammarPracticeListTopicsList(language: string, proficiencyLevel?: GrammarPracticeListTopicsListProficiencyLevelEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<GrammarTopic>> {
            return localVarFp.grammarPracticeListTopicsList(language, proficiencyLevel, options).then((request) => request(axios, basePath));
        },
        /**
         * Get user\'s exercise attempt history
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grammarPracticeMyAttemptsList(options?: RawAxiosRequestConfig): AxiosPromise<Array<UserExerciseAttempt>> {
            return localVarFp.grammarPracticeMyAttemptsList(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GrammarPracticeApi - object-oriented interface
 * @export
 * @class GrammarPracticeApi
 * @extends {BaseAPI}
 */
export class GrammarPracticeApi extends BaseAPI {
    /**
     * Check if the user\'s answer to an exercise is correct
     * @param {CheckAnswerRequestRequest} checkAnswerRequestRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrammarPracticeApi
     */
    public grammarPracticeCheckAnswerCreate(checkAnswerRequestRequest: CheckAnswerRequestRequest, options?: RawAxiosRequestConfig) {
        return GrammarPracticeApiFp(this.configuration).grammarPracticeCheckAnswerCreate(checkAnswerRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a random exercise based on filters (language, proficiency level, grammar topic)
     * @param {ExerciseRequestRequest} exerciseRequestRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrammarPracticeApi
     */
    public grammarPracticeGetExerciseCreate(exerciseRequestRequest: ExerciseRequestRequest, options?: RawAxiosRequestConfig) {
        return GrammarPracticeApiFp(this.configuration).grammarPracticeGetExerciseCreate(exerciseRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List available grammar topics for a language with optional proficiency level filter
     * @param {string} language ISO 639 language code (required)
     * @param {GrammarPracticeListTopicsListProficiencyLevelEnum} [proficiencyLevel] CEFR proficiency level (optional - will list all levels if not provided)  * &#x60;A1&#x60; - A1 * &#x60;A2&#x60; - A2 * &#x60;B1&#x60; - B1 * &#x60;B2&#x60; - B2 * &#x60;C1&#x60; - C1 * &#x60;C2&#x60; - C2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrammarPracticeApi
     */
    public grammarPracticeListTopicsList(language: string, proficiencyLevel?: GrammarPracticeListTopicsListProficiencyLevelEnum, options?: RawAxiosRequestConfig) {
        return GrammarPracticeApiFp(this.configuration).grammarPracticeListTopicsList(language, proficiencyLevel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get user\'s exercise attempt history
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrammarPracticeApi
     */
    public grammarPracticeMyAttemptsList(options?: RawAxiosRequestConfig) {
        return GrammarPracticeApiFp(this.configuration).grammarPracticeMyAttemptsList(options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GrammarPracticeListTopicsListProficiencyLevelEnum = {
    A1: 'A1',
    A2: 'A2',
    B1: 'B1',
    B2: 'B2',
    C1: 'C1',
    C2: 'C2'
} as const;
export type GrammarPracticeListTopicsListProficiencyLevelEnum = typeof GrammarPracticeListTopicsListProficiencyLevelEnum[keyof typeof GrammarPracticeListTopicsListProficiencyLevelEnum];


/**
 * TextToSpeechApi - axios parameter creator
 * @export
 */
export const TextToSpeechApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        textToSpeechCreate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/text_to_speech/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TextToSpeechApi - functional programming interface
 * @export
 */
export const TextToSpeechApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TextToSpeechApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async textToSpeechCreate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.textToSpeechCreate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TextToSpeechApi.textToSpeechCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TextToSpeechApi - factory interface
 * @export
 */
export const TextToSpeechApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TextToSpeechApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        textToSpeechCreate(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.textToSpeechCreate(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TextToSpeechApi - object-oriented interface
 * @export
 * @class TextToSpeechApi
 * @extends {BaseAPI}
 */
export class TextToSpeechApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TextToSpeechApi
     */
    public textToSpeechCreate(options?: RawAxiosRequestConfig) {
        return TextToSpeechApiFp(this.configuration).textToSpeechCreate(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get list of all available languages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersAvailableLanguagesRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/available_languages/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new user with default conversation
         * @param {UserCreateRequest} userCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersCreateUserCreate: async (userCreateRequest: UserCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userCreateRequest' is not null or undefined
            assertParamExists('usersCreateUserCreate', 'userCreateRequest', userCreateRequest)
            const localVarPath = `/users/create_user/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Health check endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersIndexRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/index/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Takes a set of user credentials and returns an access and refresh JSON web token pair to prove the authentication of those credentials.
         * @param {TokenObtainPairRequest} tokenObtainPairRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersTokenCreate: async (tokenObtainPairRequest: TokenObtainPairRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenObtainPairRequest' is not null or undefined
            assertParamExists('usersTokenCreate', 'tokenObtainPairRequest', tokenObtainPairRequest)
            const localVarPath = `/users/token/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tokenObtainPairRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
         * @param {TokenRefreshRequest} tokenRefreshRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersTokenRefreshCreate: async (tokenRefreshRequest: TokenRefreshRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenRefreshRequest' is not null or undefined
            assertParamExists('usersTokenRefreshCreate', 'tokenRefreshRequest', tokenRefreshRequest)
            const localVarPath = `/users/token/refresh/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tokenRefreshRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get user configuration options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserOptionsRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/user_options/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get detailed user profile information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserProfileRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/user_profile/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * Get list of all available languages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersAvailableLanguagesRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UsersAvailableLanguagesRetrieve200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersAvailableLanguagesRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersAvailableLanguagesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new user with default conversation
         * @param {UserCreateRequest} userCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersCreateUserCreate(userCreateRequest: UserCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersCreateUserCreate(userCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersCreateUserCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Health check endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersIndexRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsersIndexRetrieve200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersIndexRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersIndexRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Takes a set of user credentials and returns an access and refresh JSON web token pair to prove the authentication of those credentials.
         * @param {TokenObtainPairRequest} tokenObtainPairRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersTokenCreate(tokenObtainPairRequest: TokenObtainPairRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenObtainPair>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersTokenCreate(tokenObtainPairRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersTokenCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
         * @param {TokenRefreshRequest} tokenRefreshRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersTokenRefreshCreate(tokenRefreshRequest: TokenRefreshRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenRefresh>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersTokenRefreshCreate(tokenRefreshRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersTokenRefreshCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get user configuration options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersUserOptionsRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserOptionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersUserOptionsRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersUserOptionsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get detailed user profile information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersUserProfileRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersUserProfileRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersUserProfileRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * Get list of all available languages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersAvailableLanguagesRetrieve(options?: RawAxiosRequestConfig): AxiosPromise<Array<UsersAvailableLanguagesRetrieve200ResponseInner>> {
            return localVarFp.usersAvailableLanguagesRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new user with default conversation
         * @param {UserCreateRequest} userCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersCreateUserCreate(userCreateRequest: UserCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserCreateResponse> {
            return localVarFp.usersCreateUserCreate(userCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Health check endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersIndexRetrieve(options?: RawAxiosRequestConfig): AxiosPromise<UsersIndexRetrieve200Response> {
            return localVarFp.usersIndexRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * Takes a set of user credentials and returns an access and refresh JSON web token pair to prove the authentication of those credentials.
         * @param {TokenObtainPairRequest} tokenObtainPairRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersTokenCreate(tokenObtainPairRequest: TokenObtainPairRequest, options?: RawAxiosRequestConfig): AxiosPromise<TokenObtainPair> {
            return localVarFp.usersTokenCreate(tokenObtainPairRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
         * @param {TokenRefreshRequest} tokenRefreshRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersTokenRefreshCreate(tokenRefreshRequest: TokenRefreshRequest, options?: RawAxiosRequestConfig): AxiosPromise<TokenRefresh> {
            return localVarFp.usersTokenRefreshCreate(tokenRefreshRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get user configuration options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserOptionsRetrieve(options?: RawAxiosRequestConfig): AxiosPromise<UserOptionsResponse> {
            return localVarFp.usersUserOptionsRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * Get detailed user profile information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserProfileRetrieve(options?: RawAxiosRequestConfig): AxiosPromise<UserProfileResponse> {
            return localVarFp.usersUserProfileRetrieve(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * Get list of all available languages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersAvailableLanguagesRetrieve(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersAvailableLanguagesRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new user with default conversation
     * @param {UserCreateRequest} userCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersCreateUserCreate(userCreateRequest: UserCreateRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersCreateUserCreate(userCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Health check endpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersIndexRetrieve(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersIndexRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Takes a set of user credentials and returns an access and refresh JSON web token pair to prove the authentication of those credentials.
     * @param {TokenObtainPairRequest} tokenObtainPairRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersTokenCreate(tokenObtainPairRequest: TokenObtainPairRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersTokenCreate(tokenObtainPairRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
     * @param {TokenRefreshRequest} tokenRefreshRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersTokenRefreshCreate(tokenRefreshRequest: TokenRefreshRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersTokenRefreshCreate(tokenRefreshRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get user configuration options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersUserOptionsRetrieve(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersUserOptionsRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get detailed user profile information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersUserProfileRetrieve(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersUserProfileRetrieve(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WordExplorerApi - axios parameter creator
 * @export
 */
export const WordExplorerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wordExplorerCreate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/word_explorer/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WordExplorerApi - functional programming interface
 * @export
 */
export const WordExplorerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WordExplorerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async wordExplorerCreate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.wordExplorerCreate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WordExplorerApi.wordExplorerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WordExplorerApi - factory interface
 * @export
 */
export const WordExplorerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WordExplorerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wordExplorerCreate(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.wordExplorerCreate(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WordExplorerApi - object-oriented interface
 * @export
 * @class WordExplorerApi
 * @extends {BaseAPI}
 */
export class WordExplorerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WordExplorerApi
     */
    public wordExplorerCreate(options?: RawAxiosRequestConfig) {
        return WordExplorerApiFp(this.configuration).wordExplorerCreate(options).then((request) => request(this.axios, this.basePath));
    }
}



